import { Button, Stack } from '@mui/material'
import { GridColumnVisibilityModel } from '@mui/x-data-grid'
import { seoViewState } from 'components/NCO/defaultModels'
import { amViewState, dmsViewState, monthlyTotalViewState, spendViewState } from './defaultModels'

const ViewFilterButtons = ({
  onChangeColumnView,
}: {
  onChangeColumnView: (newVisibilityState: GridColumnVisibilityModel, newVisibilityTitle?: string) => void
}) => {
  return (
    <Stack gap={1}>
      {/* <Button onClick={() => onChangeVisibility('Account Manager View', amViewState)} variant="outlined"> */}
      <Button onClick={() => onChangeColumnView(amViewState)} variant="outlined">
        AM VIEW
      </Button>
      <Button
        // onClick={() => onChangeVisibility('Digital Marketing Specialist View', dmsViewState)}
        onClick={() => onChangeColumnView(dmsViewState)}
        variant="outlined"
      >
        DMS VIEW
      </Button>
      {/* <Button onClick={() => onChangeVisibility('SEO View', seoViewState)} variant="outlined"> */}
      <Button onClick={() => onChangeColumnView(seoViewState)} variant="outlined">
        SEO VIEW
      </Button>
      {/* <Button onClick={() => onChangeVisibility('Spend View', spendViewState)} variant="outlined"> */}
      <Button onClick={() => onChangeColumnView(spendViewState)} variant="outlined">
        SPEND VIEW
      </Button>
      <Button
        // onClick={() => onChangeVisibility('Monthly Total View', monthlyTotalViewState)}
        onClick={() => onChangeColumnView(monthlyTotalViewState)}
        variant="outlined"
      >
        MO. TOTAL VIEW
      </Button>
    </Stack>
  )
}

export default ViewFilterButtons
